<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h3>Scheduling Config</h3>
    </div>
    <div class="col-xs-12 col-md-6  vcenter-right">
      <div>
      </div>
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />

  <div class="row top10">
    <div class="col-xs-12">

      <mat-tab-group>
        <mat-tab label="Organizations/Types">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">

                <aims-common-table
                        id="orgs-table"
                        [dataSource]="organizations | async"
                        [defaultTableState] = "{ sort:{ active : 'organizationName', direction: 'asc' }}"
                        [header]="orgsTableHeader"
                        [permissions]="orgsTablePermissions | async"
                        [addRowInitialObject]="defaultOrganization"
                        (rowAdded)="handleOrgRowUpdate($event)"
                        (rowUpdated)="handleOrgRowUpdate($event)"
                        [pageSize]="10"
                        [stickyHeader]="true">
                  <aims-common-table-dynamic-row id="organizationTypeId">
                    <ng-template viewMode let-element >
                      {{ element.organizationTypeId | getText:'organizationTypeId':'organizationTypeCode':organizationType | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                        <mat-select style="width: 100px" [formControl]="dynamicControl" name="organizationTypeId">
                          <mat-option *ngFor="let o of organizationType | async" [value]="o.organizationTypeId">
                            {{ o.organizationTypeCode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let o of organizationType | async" [value]="o.organizationTypeId">
                            {{ o.organizationTypeCode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="contactPhone">
                    <ng-template viewMode let-element>
                      {{ element.contactPhone | mask: '000-000-0000' }}
                    </ng-template>
                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <mat-form-field appearance="fill" style="margin-top: 10px">
                        <mat-label>Contact #</mat-label>
                        <input type="text" [validation]="false" [formControl]="dynamicControl" matInput mask="000-000-0000" placeholder="999-999-9999">
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>
              </div>

              <div class="col-xs-4">
                <aims-common-table
                  id="org-type-table"
                  [dataSource]="organizationType | async"
                  [defaultTableState] = "{ sort:{ active : 'organizationTypeCode', direction: 'asc' }}"
                  [header]="orgTypeTableHeader"
                  [permissions]="orgTypeTablePermissions | async"
                  [addRowInitialObject]="defaultOrganizationType"
                  (rowAdded)="handleOrgTypeRowUpdate($event)"
                  (rowUpdated)="handleOrgTypeRowUpdate($event)"
                  [pageSize]="5"
                  [stickyHeader]="true">

                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>
        <mat-tab label="Resources">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-12">
                <aims-common-table
                  id="res-table"
                  [dataSource]="resources | async"
                  [header]="resTableHeader"
                  [permissions]="resTablePermissions | async"
                  [addRowInitialObject]="defaultResource"
                  (rowAdded)="handleResRowUpdate($event)"
                  (rowUpdated)="handleResRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                  <!-- [defaultTableState] = "{ sort:{ active : 'fullName', direction: 'asc' }}" -->

                  <aims-common-table-dynamic-row id="gradeId">
                    <ng-template viewMode let-element >
                      {{ element.gradeId | getText:'gradeId':'grade':grade | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <aims-lookup [formControl]="dynamicControl"
                        name="Grade"
                        [gridText]="'Select a Grade for this Resource'"
                        [values]="grade | async"
                        [idPropertyName]="'gradeId'"
                        [displayPropertyName]="'grade'"
                        [(ngModel)]="element.gradeId"
                        [columnsInGrid]="gradeLookupColumns"
                      >
                      </aims-lookup>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let g of grade | async" [value]="g.gradeId">
                            {{ g.grade }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="clearanceId">
                    <ng-template viewMode let-element >
                      {{ element.clearanceId | getText:'clearanceId':'clearanceName':clearance | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                        <mat-select style="width: 100px" [formControl]="dynamicControl" name="clearanceId">
                          <mat-option *ngFor="let c of clearance | async" [value]="c.clearanceId">
                            {{ c.clearanceName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let c of clearance | async" [value]="c.clearanceId">
                            {{ c.clearanceName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="genderTypeId">
                    <ng-template viewMode let-element >
                      {{ element.genderTypeId | getText:'genderTypeId':'genderTypeCode':genderType | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                        <mat-select style="width: 100px" [formControl]="dynamicControl" name="genderTypeId">
                          <mat-option *ngFor="let g of genderType | async" [value]="g.genderTypeId">
                            {{ g.genderTypeCode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let g of genderType | async" [value]="g.genderTypeId">
                            {{ g.genderTypeCode }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="organizationId">
                    <ng-template viewMode let-element >
                      {{ element.organizationId | getText:'organizationId':'organizationName':organizations | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                        <mat-select style="width: 100px" [formControl]="dynamicControl" name="organizationId">
                          <mat-option *ngFor="let o of organizations | async" [value]="o.organizationId">
                            {{ o.organizationName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let o of organizations | async" [value]="o.organizationId">
                            {{ o.organizationName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Type">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-12">
                <aims-common-table
                  id="sched-item-type-table"
                  [dataSource]="scheduleItemType | async"
                  [header]="schedItemTypeTableHeader"
                  [permissions]="schedItemTypeTablePermissions | async"
                  [addRowInitialObject]="defaultScheduleItemType"
                  (rowAdded)="handleSchedItemTypeRowUpdate($event)"
                  (rowUpdated)="handleSchedItemTypeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">

                  <aims-common-table-dynamic-row id="color">
                    <ng-template viewMode let-element >
                      <p [ngStyle]="{'background-color':element.color}">&nbsp;</p>
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <color-compact [formControl]="dynamicControl" name="color"
                        [color]="element.color" (onChangeComplete)="colorChangeComplete($event, element)" >
                      </color-compact>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="icon">
                    <ng-template viewMode let-element >
                      <i class="{{ element.icon }}"></i> - {{ element.icon }}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <mat-form-field appearance="fill" class="editable-text-field"  >
                        <input matInput type="text" name="icon" [formControl]="dynamicControl" />
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>

              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Clearance">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-6">
                <aims-common-table
                  id="clearance-table"
                  [dataSource]="clearance | async"
                  [header]="clearanceTableHeader"
                  [permissions]="clearanceTablePermissions | async"
                  [addRowInitialObject]="defaultClearance"
                  (rowAdded)="handleClearanceRowUpdate($event)"
                  (rowUpdated)="handleClearanceRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Sites">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
              <aims-common-table
                  id="sites-table"
                  [dataSource]="travelSites | async"
                  [header]="sitesTableHeader"
                  [permissions]="sitesTablePermissions | async"
                  [addRowInitialObject]="defaultSite"
                  (rowAdded)="handleSiteRowUpdate($event)"
                  (rowUpdated)="handleSiteRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Grade/Rank">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="grade-table"
                  [dataSource]="grade | async"
                  [header]="gradeTableHeader"
                  [permissions]="tablePermissions | async"
                  [addRowInitialObject]="defaultGrade"
                  (rowAdded)="handleGradeRowUpdate($event)"
                  (rowUpdated)="handleGradeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">

                </aims-common-table>

              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Minimum Number of Permanents">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">

                <aims-common-table
                  id="min-perms-table"
                  [dataSource]="minPermPos | async"
                  [header]="minPermPosTableHeader"
                  [permissions]="tablePermissions | async"
                  [addRowInitialObject]="defaultMinPermPos"
                  (rowAdded)="handleMinPermPosRowUpdate($event)"
                  (rowUpdated)="handleMinPermPosRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">

                <aims-common-table-dynamic-row id="siteId">
                    <ng-template viewMode let-element >
                      {{ element.siteId | getText:'siteId':'siteName':companySites | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                        <mat-select style="width: 100px" [formControl]="dynamicControl" name="siteId">
                          <mat-option *ngFor="let s of companySites | async" [value]="s.siteId">
                            {{ s.siteName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let s of companySites | async" [value]="s.siteId">
                            {{ s.siteName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="jobTitleId">
                    <ng-template viewMode let-element >
                      {{ element.jobTitleId | getText:'jobTitleId':'jobTitle':jobTitles | async}}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <mat-form-field appearance="fill" class="form-component" class="editable-text-field">
                        <mat-select style="width: 100px" [formControl]="dynamicControl" name="jobTitleId">
                          <mat-option *ngFor="let j of jobTitles | async" [value]="j.jobTitleId">
                            {{ j.jobTitle }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>

                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let j of jobTitles | async" [value]="j.jobTitleId">
                            {{ j.jobTitle }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Travel Task Codes">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="trvl-task-codes-table"
                  [dataSource]="travelTaskCodes | async"
                  [header]="travelTaskCodesTableHeader"
                  [permissions]="tablePermissions | async"
                  [addRowInitialObject]="defaultTravelTaskCode"
                  (rowAdded)="handleTravelTaskCodeRowUpdate($event)"
                  (rowUpdated)="handleTravelTaskCodeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">

                </aims-common-table>

              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Travel Request Emails">
          <ng-template matTabContent>
          <div class="row top 20">
            <div class="col-xs-11">
              Travel requests which are sent externally will go to ALL email addresses on this list.
            </div>
          </div>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="trvl-request-emails-table"
                  [dataSource]="travelRequestEmails | async"
                  [header]="travelRequestEmailsTableHeader"
                  [permissions]="travelRequestEmailsTablePermissions | async"
                  [addRowInitialObject]="defaultEmail"
                  (rowAdded)="handleTravelRequestEmailRowUpdate($event)"
                  (rowUpdated)="handleTravelRequestEmailRowUpdate($event)"
                  (rowDeleted)="handleTravelRequestEmailRowDelete($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">

                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

      <mat-tab label="Lodging Options">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="lodging-options-table"
                  [dataSource]="lodgingAuthTypeValues | async"
                  [header]="lodgingAuthTypeTableHeader"
                  [permissions]="lodgingAuthTypeTablePermissions | async"
                  [addRowInitialObject]="defaultLodgingAuthType"
                  (rowAdded)="handleLodgingAuthTypeRowUpdate($event)"
                  (rowUpdated)="handleLodgingAuthTypeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Rental Car Options">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="rental-car-options-table"
                  [dataSource]="rentalCarAuthTypeValues | async"
                  [header]="rentalCarAuthTypeTableHeader"
                  [permissions]="rentalCarAuthTypeTablePermissions | async"
                  [addRowInitialObject]="defaultRentalCarAuthType"
                  (rowAdded)="handleRentalCarAuthTypeRowUpdate($event)"
                  (rowUpdated)="handleRentalCarAuthTypeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Flight Options">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="flight-options-table"
                  [dataSource]="flightAuthTypeValues | async"
                  [header]="flightAuthTypeTableHeader"
                  [permissions]="flightAuthTypeTablePermissions | async"
                  [addRowInitialObject]="defaultFlightAuthType"
                  (rowAdded)="handleFlightAuthTypeRowUpdate($event)"
                  (rowUpdated)="handleFlightAuthTypeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab label="Travel Request Options">
          <ng-template matTabContent>
            <aims-form [editable]="true" [cols]="1" [spaceRows]="true">
              <aims-fc [labelColSize]="2" [controlColSize]="6">
                <mat-form-field appearance="fill">
                  <textarea matInput
                    #aimsControl="ngModel"
                    name="Additional Notes"
                    placeholder="Additional Notes"
                    [(ngModel)]="trvlRequestConfig.addlNotesText"
                    (blur)="updateConfig()"
                    rows="10"
                    maxlength="1000" >
                  </textarea>
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </ng-template>
        </mat-tab>

        <mat-tab label="Traveler Types">
          <ng-template matTabContent>
            <div class="row top20 table-container">
              <div class="col-xs-8">
                <aims-common-table
                  id="traveler-types-table"
                  [dataSource]="travelerTypeValues | async"
                  [header]="travelerTypeTableHeader"
                  [permissions]="travelerTypeTablePermissions | async"
                  [addRowInitialObject]="defaultTravelerType"
                  (rowAdded)="handleTravelerTypeRowUpdate($event)"
                  (rowUpdated)="handleTravelerTypeRowUpdate($event)"
                  [pageSize]="10"
                  [stickyHeader]="true">
                </aims-common-table>
              </div>
            </div>

          </ng-template>
        </mat-tab>

      </mat-tab-group>
    </div>

    <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

  </div>
</div>
